module.exports = __webpack_public_path__ + "img/logo_islami-oteller.a313481b.png";